import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[480px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20warm%20abstract%20artistic%20gradient%20composition%20with%20soft%20coral%20red%20and%20warm%20amber%20tones%20flowing%20organic%20shapes%20modern%20minimalist%20aesthetic%20subtle%20cherry%20blossom%20inspired%20textures%20elegant%20atmospheric%20background%20for%20a%20video%20content%20platform&width=1800&height=900&seq=hero-bg-main&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
          发现值得关注的
          <span className="text-accent-400"> 优质视频内容</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          樱桃视频为你精选热门视频资讯、深度行业分析和实用观看指南，让好内容被更多人看见
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/hot"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            探索热门内容
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}